import React, { useState, useEffect } from 'react';
import { Modal, Table } from 'react-bootstrap';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';
import { IoPeopleOutline, IoWalletOutline, IoCashOutline, IoShieldCheckmarkOutline } from 'react-icons/io5';
import './LevelUserListModal.css';

export default function LevelUserListModal({ show, onClose, walletAddress, level }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
  const BASE_URL = environment === 'production' 
    ? process.env.REACT_APP_PROD_API_URL 
    : environment === 'staging' 
      ? process.env.REACT_APP_STAG_API_URL 
      : process.env.REACT_APP_DEV_API_URL || 'http://localhost:4001';

  useEffect(() => {
    if (show && walletAddress && level) {
      setLoading(true);
      axios.get(`${BASE_URL}/v1/validator-delegator/level-users`, {
        params: { walletAddress, level },
        headers: { "Authorization": `Bearer ${localStorage.getItem("acessToken")}` }
      })
        .then(res => setUsers(res.data.data))
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [show, walletAddress, level, BASE_URL]);

  return (
    <Modal show={show} onHide={onClose} centered size="xl" contentClassName="custom-modal-37">
      <Modal.Header closeButton className="border-0 py-3 px-4" style={{ background: 'linear-gradient(90deg, #234B9A 0%, #4a74c9 100%)', color: 'white' }}>
        <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2">
          <IoPeopleOutline size={20} />
          Users in Level {level}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 bg-white">
        {loading ? (
          <div className="p-5 text-center"><Loader /></div>
        ) : users.length > 0 ? (<>
          {/* Summary Cards for this Level */}
          <div className="row g-0 border-bottom">
            <div className="col-4 border-end py-3 text-center bg-light bg-opacity-50">
               <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '10px' }}>Level Validator (No.)</div>
               <div className="fs-5 fw-bold text-primary">
                 {users.reduce((acc, u) => acc + (u.validatorCount || 0), 0)}
               </div>
            </div>
            <div className="col-4 border-end py-3 text-center bg-light bg-opacity-50">
               <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '10px' }}>Level Delegator (No.)</div>
               <div className="fs-5 fw-bold text-info">
                 {users.reduce((acc, u) => acc + (u.delegatorCount || 0), 0)}
               </div>
            </div>
            <div className="col-4 py-3 text-center bg-light bg-opacity-50">
               <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '10px' }}>Level Total Purchase (Amt.)</div>
               <div className="fs-5 fw-bold text-success">
                 ${users.reduce((acc, u) => acc + (u.totalInvested || 0), 0).toLocaleString()}
               </div>
            </div>
          </div>

          <Table hover className="mb-0 w-100 align-middle border-0">
            <thead className="bg-light small text-uppercase text-muted border-bottom">
              <tr>
                <th className="ps-4 py-2 text-start" style={{ width: '40%' }}>User Details</th>
                <th className="py-2 text-center" style={{ width: '20%' }}><IoShieldCheckmarkOutline /> Validator (No.)</th>
                <th className="py-2 text-center" style={{ width: '20%' }}><IoPeopleOutline /> Delegator (No.)</th>
                <th className="pe-4 py-2 text-end" style={{ width: '20%' }}><IoCashOutline /> Total (Amt.)</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, idx) => (
                <tr key={idx} className="border-bottom">
                  <td className="ps-4 py-2">
                    <div className="fw-bold text-dark" style={{ fontSize: '13px' }}>{user.username}</div>
                    <div className="text-muted x-small font-monospace d-flex align-items-center gap-1" style={{ fontSize: '11px' }}>
                      <IoWalletOutline size={12} /> {user.walletAddress.slice(0, 10)}...{user.walletAddress.slice(-8)}
                    </div>
                  </td>
                  <td className="py-2 text-center">
                     <span className={`fw-bold ${user.validatorCount > 0 ? 'text-primary' : 'text-secondary opacity-75'}`} style={{ fontSize: '13px' }}>
                       {user.validatorCount}
                     </span>
                  </td>
                  <td className="py-2 text-center">
                     <span className={`fw-bold ${user.delegatorCount > 0 ? 'text-info' : 'text-secondary opacity-75'}`} style={{ fontSize: '13px' }}>
                       {user.delegatorCount}
                     </span>
                  </td>
                  <td className="pe-4 py-2 text-end fw-bold text-dark" style={{ fontSize: '13px' }}>
                    ${user.totalInvested.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>) : (
          <div className="p-5 text-center text-muted">
             <IoPeopleOutline size={40} className="mb-2 opacity-25" />
             <p className="mb-0">No users found at this level.</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
